/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-05-16 20:54:38
 * @LastEditors: kevinqq 350910378@qq.com
 * @LastEditTime: 2025-03-12 10:58:02
 * @FilePath: \baishu_react_ui\src\components\dashboard\BsyDashboardCustomApp\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { BsyUtils } from "../../../utils/Utils";
import "./index.css";

class BsyDashboardDockApp extends Component {
  static defaultProps = {
    dockApp: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      dockApp: props.dockApp,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    const dockApp = { ...nextProps.dockApp };
    this.setState({
      dockApp: dockApp,
    });
  }

  selectApp = (appinfo) => {
    // console.log('selectApp', appinfo)
    this.props.history.push(`${window.rootDirectroy}/team/app/${appinfo._id}`);
    // if (this.props.onSelectApp) {
    //     this.props.onSelectApp(appinfo)
    // }
  };

  render() {
    const { dockApp } = this.state;
    const boxWidth =
      this.props.mode === "edit"
        ? document.querySelector("#bby").clientWidth - 340
        : document.querySelector("#bby").clientWidth - 90;
    const totalMargin = boxWidth % 190;

    let ars = [];
    if (dockApp.apps) {
      if (Array.isArray(dockApp.apps)) {
        ars = dockApp.apps;
      } else {
        for (let key in dockApp.apps) {
          ars.push(dockApp.apps[key]);
        }
      }
    }
    return (
      <div className={"dashboard-dock-app " + this.props.mode}>
        <div className="bys-group-box">
        {ars.length > 0 ? (
                ars.map((data, index) => {
                  return (
                    <div
                      className="bys-group-box-item "
                      style={{
                        marginBottom: `16px`,
                      }}
                      id={data._id}
                      onClick={this.selectApp.bind(this, data, index)}
                      key={"box-" + index}
                    >
                      <div className="view">
                        <div className="app-wrapper">
                          <div className="icon-wrapper">
                            <div
                              className={
                                "icon-backgroup color-cover-" + data.style.color
                              }
                            >
                              <div
                                className={
                                  "imgbg-bsy-app imgbg-bsy-app-" +
                                  data.style.icon
                                }
                              ></div>
                            </div>
                          </div>
                          <div
                            className="app-title"
                            title={data.appname}
                            id={"app_title_" + data._id}
                          >
                            {data.appname}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="dock-app-empty">
                  {React.language("data.dock.empty")}
                </div>
              )}
        </div>
      </div>
    );
  }
}

export default withRouter(BsyDashboardDockApp);
